<div class="container" [class.no-padding]="!paddingTop">
  <ng-container>
    <div class="row">
      <div class="col s12 m12 l12 iframe-column">
        @if (teacher) {
          <p matRipple class="back-text" (click)="back()">
            <mat-icon>arrow_back</mat-icon>
            {{ 'general.words.back' | translate | capitalize }}
          </p>
        }
        @if (loading) {
          <app-skeleton-case></app-skeleton-case>
        }
        @if (case && !loading) {
          <mat-card appearance="outlined" class="card-primary iframe-card" style="padding-bottom: 0px">
            <div class="iframe-header">
              <h1>{{ case.title }}</h1>
              @if ((!case.isQuiz || (case.isQuiz && !quizResult)) && case.iframeUrl) {
                <button
                  mat-icon-button
                  color="primary"
                  class="open-external-button"
                  [matTooltip]="'case.open-in-new-tab' | translate | capitalize"
                  (click)="openIframeDialog()">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              }
              @if (teacher) {
                <div class="edit-case-button">
                  <button
                    mat-icon-button
                    color="primary"
                    [matTooltip]="'case.edit-workgroups' | translate | capitalize"
                    (click)="openEditWorkgroups()">
                    <mat-icon>group</mat-icon>
                  </button>
                  <button
                    [disabled]="case && case.lockedByAdmin && !isUserSuperAdmin"
                    mat-icon-button
                    color="primary"
                    [matTooltip]="'case.edit-case' | translate | capitalize"
                    (click)="editCase()">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              }
            </div>
            @if (!case.isQuiz || (case.isQuiz && !quizResult)) {
              @if (case.iframeUrl) {
                <iframe class="iframe" [class.iframe-student]="!teacher" [src]="iframeSafeUrl" frameborder="0"></iframe>
              }
              @if (!case.iframeUrl) {
                <div class="iframe-replacement">
                  <p>
                    <i>{{ 'case.no-linked-case' | translate | capitalize }}</i>
                  </p>
                </div>
              }
            }
            @if (quizResult) {
              <h3 class="bold">
                {{ 'case.quiz.results-title' | translate | capitalize }}
              </h3>
              <p style="display: inline-flex; vertical-align: middle">
                <span style="margin-right: 5px">
                  {{ 'case.quiz.score' | translate }}: {{ quizResult.score }} {{ 'case.quiz.max-score' }}
                  {{ quizResult.maxScore }}</span
                >
                @if (checkIfQuizResultPassed()) {
                  <mat-icon style="color: green; margin-top: -4px"> check_circle </mat-icon>
                }
                @if (!checkIfQuizResultPassed()) {
                  <mat-icon style="color: red; margin-top: -4px">cancel </mat-icon>
                }
              </p>
              <p style="padding-bottom: 10px">
                <span>
                  {{
                    'case.quiz.registered'
                      | translate
                        : {
                            DATE: quizResult.registered | date: 'dd-MM-yyyy',
                            TIME: quizResult.registered | date: 'HH:mm',
                          }
                      | capitalize
                  }} </span
                ><br />
                <span
                  >{{ 'case.quiz.used-time' | translate | capitalize }}&nbsp;{{
                    quizResult.usedTime
                  }}&nbsp;<ng-container>{{ 'general.words.seconds' | translate }}</ng-container></span
                >
              </p>
            }
          </mat-card>
        }
      </div>
      <div class="col s12 m12 l12 others-column">
        @if (patientLoading) {
          <app-skeleton-case-patient [teacher]="teacher"></app-skeleton-case-patient>
        }
        @if (!this.patientLoading) {
          <mat-card
            appearance="outlined"
            appearance="outlined"
            class="card-primary patient-card"
            [class.patient-card-teacher]="teacher">
            <div class="patient-img-wrapper">
              @if (patientImageUrl === 'icon') {
                <mat-icon class="profile-img">account_box</mat-icon>
              }
              @if (patientImageUrl !== 'icon') {
                <img
                  class="profile-img"
                  defaultImage="/assets/images/loader1.gif"
                  [lazyLoad]="patientImageUrl | authImage | async" />
              }
            </div>
            @if (this.case.patient.properties) {
              <div class="patient-info-wrapper">
                @if (this.case?.patient?.department?.careInstitution?.backgroundInformationUrl) {
                  <div class="background-info-btn-section">
                    <button
                      mat-icon-button
                      class="background-info-btn"
                      (click)="openBackgroundUrl()"
                      [matTooltip]="'case.organisation-info' | translate | capitalize"
                      color="primary">
                      <mat-icon>info</mat-icon>
                    </button>
                  </div>
                }
                <p class="patient-title">{{ getPatientProperty('zoeknaam') }}</p>
                <p class="patient-birthdate">
                  {{ getPatientProperty('geboortedatum') | date: 'dd-MM-yyyy' }}
                </p>
                <p class="patient-department">
                  {{ case.patient.department.careInstitution.name }},&nbsp;{{ case.patient.department.name }},&nbsp;
                </p>
                @if (case.role) {
                  <p class="patient-department">
                    {{ case.role.name }}
                  </p>
                }
              </div>
            }
          </mat-card>
        }
        @if (tasksLoading) {
          <app-skeleton-tasks></app-skeleton-tasks>
        }
        @if (!tasksLoading) {
          <mat-card class="card-primary" appearance="outlined">
            <h1 mat-card-title>
              {{ 'case.tasks.title' | translate | capitalize }}
            </h1>
            @if (!tasksLoading && case) {
              <app-task-list
                [tasks]="case.tasks"
                [caseId]="case.id"
                [variant]="!teacher ? 'student' : 'teacher'"
                [workgroups]="!teacher ? studentWorkgroups : undefined"
                [showOpenTaskButton]="true"
                (onTaskClick)="!teacher ? openRegistration($event) : openTask($event)">
              </app-task-list>
            }
          </mat-card>
        }
      </div>
    </div>
  </ng-container>
</div>
